import React, {PropsWithChildren, useEffect} from "react";
import styles from "./PreviewCarousel.module.css";
import {useSelector} from "react-redux";
import {RootState} from "../../store";

interface Props extends PropsWithChildren {
    videos: any[];
    activeIndex: number;
    onChange: (i: number) => void;
    interval?: number;
    isLocked?: boolean;
}

export const PreviewCarouselSlideshow: React.FC<Props> = ({
                                                              videos,
                                                              activeIndex,
                                                              onChange,
                                                              children,
                                                              interval = 10000,
                                                              isLocked = false,
                                                          }) => {


    const {isPreviewPlaying,} = useSelector(
        (state: RootState) => state.videoPlayer);


    // Якщо немає відео — не включаємо карусель
    if (!videos || !Array.isArray(videos) || videos.length === 0) {
        return <div className={styles.wrapper}>{children}</div>;
    }

    // Автопрокрутка (працює тільки коли відео НЕ відтворюється)
    useEffect(() => {
        if (isLocked) return;    // ← БЛОКУЄМО autoplay

        const timer = setInterval(() => {
            onChange((activeIndex + 1) % videos.length);
        }, interval);

        return () => clearInterval(timer);
    }, [activeIndex, videos, interval, isLocked]);
    return (
        <div className={styles.wrapper}>
            <div
                className={styles.slider}
                style={{transform: `translateX(-${activeIndex * 100}%)`}}
            >
                {videos.map((v, i) => (
                    <div
                        key={i}
                        className={styles.slide}
                        style={{
                            backgroundImage: `url(${v.backdrop_path})`
                        }}
                    />
                ))}
            </div>

            {/* 🔥 Ось цей шар плавно затемнює фон */}
            <div
                className={styles.blackOverlay}
                style={{
                    opacity: isPreviewPlaying ? 1 : 0
                }}
            />

            <div className={styles.overlay}>{children}</div>

            <div className={styles.dots}>
                {videos.map((_, i) => (
                    <div
                        key={i}
                        onClick={() => onChange(i)}
                        className={`${styles.dot} ${i === activeIndex ? styles.active : ""}`}
                    />
                ))}
            </div>
        </div>

    );
};
